<template lang="html">
    <div class="lessonProDatePicker">
        <button
            v-if="!calendarOpen"
            @click.prevent="openCalendar"
            class="button dark alignLeft"
            type="button"
            name="button"
            :class="{ complete: inputVal }"
        >
            {{ dateSelected ? $date(day.date).format("ddd D MMM YYYY") : "Select date" }}
            <img class="arrow" src="~@/assets/arrow-right-white-2.svg" />
        </button>

        <date-picker
            v-if="calendarOpen && !dateSelected"
            v-model="day"
            mode="date"
            timezone="Europe/London"
            :min-date="new Date()"
            :disabled-dates="{}"
            :available-dates="availableDates"
            ref="calendar"
            @update:to-page="changeMonth"
            @dayclick="selectDate"
            class="datePicker"
            :value="new Date()"
        />
    </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
export default {
    name: "lesson-pro-date-picker",
    components: { "date-picker": DatePicker },
    watch: {
        value(to) {
            if (this.$route.name == "proLessonChange" || this.$route.name == "LessonChange") {
                this.dateSelected = to;
                this.day = { date: to };
            }
        },
    },
    props: {
        type: {
            type: String,
            required: true,
        },
        value: {},
        duration: {
            type: String,
        },
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        availableDates() {
            return {
                days: this.dates.map(($date) => {
                    if (this.$date($date.date).isSameOrAfter(this.$date(), "day")) {
                        return Number(this.$date($date.date).format("DD"));
                    }
                }),
            };
        },
    },
    data() {
        return {
            calendarOpen: false,
            calendar: false,
            dates: [],
            datesLoaded: false,
            dateSelected: false,
            day: new Date(),
        };
    },
    mounted() {
        this.calendar = this.$refs.calendar;

        if (this.$route.name == "proLessonChange" || this.$route.name == "LessonChange") {
            this.day = this.inputVal;
            this.dateSelected = this.inputVal;
        }
    },
    methods: {
        resetCalendar() {
            this.dateSelected = false;
            this.calendarOpen = false;
        },
        openCalendar() {
            this.calendarOpen = true;
            this.dateSelected = false;
            this.$emit("calendarOpen");
        },
        getAvailability($monthYear) {
            window.axios
                .get(
                    "/booking/availability?month=" +
                        $monthYear["month"] +
                        "&year=" +
                        $monthYear["year"] +
                        "&duration=" +
                        this.duration,
                )
                .then((response) => {
                    this.dates = response.data;
                    this.datesLoaded = true;
                    this.disabledDates = false;
                });
        },
        selectDate(calendarDate) {
            if (calendarDate.isDisabled) {
                return;
            }
            this.calendarOpen = false;
            this.dateSelected = true;
            this.inputVal = calendarDate.date;
            this.day = calendarDate;

            // get the array of dates for the chosen dates
            var filtered = this.dates.filter((date) => {
                return this.$date(calendarDate.date)
                    .startOf("day")
                    .isSame(this.$date(date.date).startOf("day"));
            });

            this.$emit("timesAdded", filtered);
        },
        changeMonth($monthYear) {
            this.dates = [];
            this.$nextTick(() => {
                this.getAvailability($monthYear);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.lessonProDatePicker {
    width: 100% !important;
    .button {
        margin-bottom: 10px;
        &.complete {
            background: white;
            color: $green_0;
        }
    }
    .arrow {
        position: absolute;
        right: 20px;
        top: 20px;
    }
    .vc-container {
        margin: 0 auto;
        margin-bottom: 20px;
        width: 100% !important;
    }
}
</style>
